export { default } from './useProductSearch';
